module.exports = {
    config: require('./config'),
    procedures: {
        customer_read: {
            definition: require('./customer_read/definition.json'),
            mock_data: require('./customer_read/mock_data.json'),
        },
        customer_create: {
            definition: require('./customer_create/definition.json'),
            mock_data: require('./customer_create/mock_data.json'),
        },
        customer_update: {
            definition: require('./customer_update/definition.json'),
            mock_data: require('./customer_update/mock_data.json'),
        },
        customer_list: {
            definition: require('./customer_list/definition.json'),
            mock_data: require('./customer_list/mock_data.json'),
        },
        customer_file_create: {
            definition: require('./customer_file_create/definition.json'),
            mock_data: require('./customer_file_create/mock_data.json'),
        },
        customer_file_list: {
            definition: require('./customer_file_list/definition.json'),
            mock_data: require('./customer_file_list/mock_data.json'),
        },
        customer_file_read: {
            definition: require('./customer_file_read/definition.json'),
            mock_data: require('./customer_file_read/mock_data.json'),
        },
        customer_file_update: {
            definition: require('./customer_file_update/definition.json'),
            mock_data: require('./customer_file_update/mock_data.json'),
        },
        contact_address_create: {
            definition: require('./contact_address_create/definition.json'),
            mock_data: require('./contact_address_create/mock_data.json'),
        },
        contact_address_list: {
            definition: require('./contact_address_list/definition.json'),
            mock_data: require('./contact_address_list/mock_data.json'),
        },
        contact_address_read: {
            definition: require('./contact_address_read/definition.json'),
            mock_data: require('./contact_address_read/mock_data.json'),
        },
        contact_address_update: {
            definition: require('./contact_address_update/definition.json'),
            mock_data: require('./contact_address_update/mock_data.json'),
        },
        contact_address_validate: {
            definition: require('./contact_address_validate/definition.json'),
            mock_data: require('./contact_address_validate/mock_data.json'),
        },
        contact_uri_create: {
            definition: require('./contact_uri_create/definition.json'),
            mock_data: require('./contact_uri_create/mock_data.json'),
        },
        contact_uri_list: {
            definition: require('./contact_uri_list/definition.json'),
            mock_data: require('./contact_uri_list/mock_data.json'),
        },
        contact_uri_read: {
            definition: require('./contact_uri_read/definition.json'),
            mock_data: require('./contact_uri_read/mock_data.json'),
        },
        contact_uri_update: {
            definition: require('./contact_uri_update/definition.json'),
            mock_data: require('./contact_uri_update/mock_data.json'),
        },
        contact_create: {
            definition: require('./contact_create/definition.json'),
            mock_data: require('./contact_create/mock_data.json'),
        },
        contact_update: {
            definition: require('./contact_update/definition.json'),
            mock_data: require('./contact_update/mock_data.json'),
        },
        contact_read: {
            definition: require('./contact_read/definition.json'),
            mock_data: require('./contact_read/mock_data.json'),
        },
        contact_tree_read: {
            definition: require('./contact_tree_read/definition.json'),
            mock_data: require('./contact_tree_read/mock_data.json'),
        },
        contact_list: {
            definition: require('./contact_list/definition.json'),
            mock_data: require('./contact_list/mock_data.json'),
        },
        contact_email_create: {
            definition: require('./contact_email_create/definition.json'),
            mock_data: require('./contact_email_create/mock_data.json'),
        },
        contact_email_list: {
            definition: require('./contact_email_list/definition.json'),
            mock_data: require('./contact_email_list/mock_data.json'),
        },
        contact_email_read: {
            definition: require('./contact_email_read/definition.json'),
            mock_data: require('./contact_email_read/mock_data.json'),
        },
        contact_email_update: {
            definition: require('./contact_email_update/definition.json'),
            mock_data: require('./contact_email_update/mock_data.json'),
        },
        contact_note_create: {
            definition: require('./contact_note_create/definition.json'),
            mock_data: require('./contact_note_create/mock_data.json'),
        },
        contact_note_update: {
            definition: require('./contact_note_update/definition.json'),
            mock_data: require('./contact_note_update/mock_data.json'),
        },
        contact_note_list: {
            definition: require('./contact_note_list/definition.json'),
            mock_data: require('./contact_note_list/mock_data.json'),
        },
        contact_phone_create: {
            definition: require('./contact_phone_create/definition.json'),
            mock_data: require('./contact_phone_create/mock_data.json'),
        },
        contact_phone_list: {
            definition: require('./contact_phone_list/definition.json'),
            mock_data: require('./contact_phone_list/mock_data.json'),
        },
        contact_phone_read: {
            definition: require('./contact_phone_read/definition.json'),
            mock_data: require('./contact_phone_read/mock_data.json'),
        },
        contact_phone_update: {
            definition: require('./contact_phone_update/definition.json'),
            mock_data: require('./contact_phone_update/mock_data.json'),
        },
        vendor_create: {
            definition: require('./vendor_create/definition.json'),
            mock_data: require('./vendor_create/mock_data.json'),
        },
        vendor_read: {
            definition: require('./vendor_read/definition.json'),
            mock_data: require('./vendor_read/mock_data.json'),
        },
        vendor_update: {
            definition: require('./vendor_update/definition.json'),
            mock_data: require('./vendor_update/mock_data.json'),
        },
        vendor_list: {
            definition: require('./vendor_list/definition.json'),
            mock_data: require('./vendor_list/mock_data.json'),
        },
        employee_create: {
            definition: require('./employee_create/definition.json'),
            mock_data: require('./employee_create/mock_data.json'),
        },
        employee_read: {
            definition: require('./employee_read/definition.json'),
            mock_data: require('./employee_read/mock_data.json'),
        },
        employee_update: {
            definition: require('./employee_update/definition.json'),
            mock_data: require('./employee_update/mock_data.json'),
        },
        employee_list: {
            definition: require('./employee_list/definition.json'),
            mock_data: require('./employee_list/mock_data.json'),
        },
        geolocale_list: {
            definition: require('./geolocale_list/definition.json'),
            mock_data: require('./geolocale_list/mock_data.json'),
        },
        contact_search_list: {
            definition: require('./contact_search_list/definition.json'),
            mock_data: require('./contact_search_list/mock_data.json'),
        },
        market_search_list: {
            definition: require('./market_search_list/definition.json'),
            mock_data: require('./market_search_list/mock_data.json'),
        }
    }
};